import decodeHTMLEntities from "../../../Components/decodeHtmlEntities";

// Extrae los datos relevantes de un CFDI ya parseado a árbol {name, attributes, children}
// (mismo formato que produce Components/xmlToJson.js o el backend en descargaMasiva/datosXml).
export function extraerDatosDesdeArbol(raiz) {
  const comprobante = raiz?.attributes;
  const emisor = raiz.children.find((v) => v.name === "cfdi:Emisor")?.attributes;
  const receptor = raiz.children.find((v) => v.name === "cfdi:Receptor")?.attributes;
  const complemento = raiz.children.find((v) => v.name === "cfdi:Complemento");
  const timbre = complemento?.children.find((v) => v.name === "tfd:TimbreFiscalDigital")?.attributes;
  const conceptosNodos = raiz.children.find((v) => v.name === "cfdi:Conceptos")?.children || [];

  const conceptos = conceptosNodos.map((valueConcepto) => {
    const attr = valueConcepto.attributes;
    let totalImpuestos = 0;
    const traslados = [];
    valueConcepto.children
      .find((v) => v.name === "cfdi:Impuestos")
      ?.children.find((v) => v.name === "cfdi:Traslados")
      ?.children.forEach((valueImpuesto) => {
        const a = valueImpuesto.attributes;
        totalImpuestos += Number(a.Importe || 0);
        traslados.push({
          impuestoCodigo: a.Impuesto,
          tipoFactor: a.TipoFactor,
          tasaOCuota: a.TasaOCuota !== undefined ? Number(a.TasaOCuota) : undefined,
          importe: Number(a.Importe || 0),
        });
      });
    return {
      codigo: attr.NoIdentificacion,
      descripcion: attr.Descripcion,
      claveProdServ: attr.ClaveProdServ,
      claveUnidad: attr.ClaveUnidad,
      precioUnitario: Number(attr.ValorUnitario),
      cantidad: Number(attr.Cantidad),
      descuento: attr.Descuento ? Math.round((attr.Descuento / attr.Importe) * 1000000) / 10000 : 0,
      impuestos: totalImpuestos,
      traslados,
    };
  });

  return {
    tipoDeComprobante: comprobante?.TipoDeComprobante,
    rfcReceptor: receptor?.Rfc,
    rfcEmisor: decodeHTMLEntities(emisor?.Rfc || ""),
    nombreEmisor: decodeHTMLEntities(emisor?.Nombre || ""),
    conceptos,
    uuid: timbre?.UUID,
    fechaFactura: comprobante?.Fecha,
    codigoFactura: (comprobante?.Serie || "") + " - " + (comprobante?.Folio || ""),
    tipoDeCambio: Number(comprobante?.TipoCambio || 1),
    monedaAbrev: comprobante?.Moneda,
    usoCfdiCodigo: receptor?.UsoCFDI,
    formaPagoCodigo: comprobante?.FormaPago,
    metodoPagoStr: comprobante?.MetodoPago,
    totalXml: Number(comprobante?.Total || 0),
    // Subtotal ya neto de descuento: es el importe del gasto en la captura por XML
    subTotalXml: Number(comprobante?.SubTotal || 0) - Number(comprobante?.Descuento || 0),
  };
}

// RFC de persona física = 13 caracteres, persona moral = 12. En Proveedor.js
// "persona: true" significa persona moral (usa razonSocial), "false" persona física (usa nombre).
export function inferirPersonaPorRfc(rfc) {
  return (rfc || "").trim().toUpperCase().length === 12;
}

// Texto legible de los impuestos que trae una línea del XML.
export function textoTraslados(traslados) {
  if (!traslados || traslados.length === 0) return "Sin impuestos";
  return traslados
    .map((t) => {
      const nombre = t.impuestoCodigo === "002" ? "IVA" : t.impuestoCodigo === "003" ? "IEPS" : t.impuestoCodigo;
      // Exento y tasa 0 NO son lo mismo: la DIOT los reporta en columnas distintas
      // (Exentos vs Base 0%). Etiquetar un "Tasa 0.000000" como Exento contradice al
      // importador, que sí los separa.
      if (t.tipoFactor === "Exento") return `${nombre} Exento`;
      if (t.tipoFactor === "Cuota") return `${nombre} cuota $${Number(t.tasaOCuota).toFixed(4)}`;
      // Sin TasaOCuota no hay porcentaje que imprimir; sin esto saldría "IVA NaN%"
      if (!Number.isFinite(Number(t.tasaOCuota))) return nombre;
      return `${nombre} ${(Number(t.tasaOCuota) * 100).toFixed(2)}%`;
    })
    .join(", ");
}

// Busca en el catálogo local de proveedores el que coincide con el RFC del emisor de un XML.
export function resolverProveedorPorRfc(todasProveedores, rfc) {
  return (todasProveedores || []).find(
    (p) => (p.rfc || "").toUpperCase() === (rfc || "").toUpperCase()
  );
}
